// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gMRM","left":"styles_left__3gHIx","desktopActions":"styles_desktopActions__vx9o8","title":"styles_title__25gsE"};